import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.r5g().w51() : headers;
  return DelegatedCall().n5i(_this__u8e3s4.m5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.n5i(client, originCall, responseContent, responseHeaders);
      }
      static n5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.r5g().w51() : responseHeaders;
        var $this = this.o5i(client);
        $this.o5g_1 = new (DelegatedRequest())($this, originCall.p5i());
        $this.p5g_1 = new (DelegatedResponse())($this, originCall.r5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.u5i_1 = origin;
        this.v5i_1 = call;
      }
      w5i() {
        return this.v5i_1;
      }
      bw() {
        return this.u5i_1.bw();
      }
      x5i() {
        return this.u5i_1.x5i();
      }
      y5i() {
        return this.u5i_1.y5i();
      }
      q5i() {
        return this.u5i_1.q5i();
      }
      z2n() {
        return this.u5i_1.z2n();
      }
      w51() {
        return this.u5i_1.w51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.w51() : headers;
        super();
        this.z5i_1 = call;
        this.a5j_1 = origin;
        this.b5j_1 = content;
        this.c5j_1 = headers;
        this.d5j_1 = this.a5j_1.bw();
      }
      w5i() {
        return this.z5i_1;
      }
      w51() {
        return this.c5j_1;
      }
      e5j() {
        return this.b5j_1(this.a5j_1);
      }
      bw() {
        return this.d5j_1;
      }
      f5j() {
        return this.a5j_1.f5j();
      }
      g5j() {
        return this.a5j_1.g5j();
      }
      h5j() {
        return this.a5j_1.h5j();
      }
      i5j() {
        return this.a5j_1.i5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
